export default "__VITE_ASSET__BP5Ct4Uu__"